module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-2fd7f8314546ab9089e55582d4835f8f.webp";